import * as $ from 'jquery';
import {delineate} from "../../lib/delineate";

var mockProductData = {
	'847087_c1': {
		image: './img/nh-products/847087_c1.jpg',
		finish: 'Spot Defense Brushed Nickel'
	},
	'847079_c1': {
		image: './img/nh-products/847079_c1.jpg',
		finish: 'Matte Black'
	},
	'847103_c1': {
		image: './img/nh-products/847103_c1.jpg',
		finish: 'Tuscan Bronze'
	},
	'847111_c1': {
		image: './img/nh-products/847111_c1.jpg',
		finish: 'Polished Chrome'
	},
	'226845_c1': {
		image: './img/nh-products/226845_c1.jpg',
		finish: 'Spot Defense Brushed Nickel'
	},
	'226852_c1': {
		image: './img/nh-products/226852_c1.jpg',
		finish: 'Matte Black'
	},
	'226878_c1': {
		image: './img/nh-products/226878_c1.jpg',
		finish: 'Tuscan Bronze'
	},
	'248427_c1': {
		image: './img/nh-products/248427_c1.jpg',
		finish: 'Polished Chrome'
	}
};


function initFinishSwitcher() {
	$('.js-finish-swatch').on('click', function (e) {
		e.preventDefault();
		// TEMPORARY: This will be replaced by an Angular component
		var $this = $(this);
		let finishName = $this.data('finish-name');
		let $activeFinishTextContainer = $this.closest('.product-card__body').find('.js-active-finish');
		let $activeImage = $this.closest('.product-card__body').find('.js-active-finish-img');
		let $selectedImageSrc = $this.find('.finish-swatch__img').attr('src');
		//console.log($selectedImageSrc);
		var newModel = $this.attr('data-model');

		// Update the selected finish in the swatch list
		var $list = $(this).closest('.finish-swatch-list');
		var $finishes = $list.find(".js-finish-swatch");
		$finishes.removeClass('state-selected');
		$(this).addClass('state-selected');
		$activeFinishTextContainer.html(finishName);
		$activeImage.attr('src', $selectedImageSrc);


		// Simulate a Lookup of the new product data and replace details as necessary
		var $card = $this.closest('.product-card');
		var $image = $card.find('.product-card__image');

		var cardData = mockProductData[newModel];
		//$.event.trigger('finishSelected');
		$image.attr('src', cardData.image);
	});

}


function initSelectableCards() {
	$('.js-product-card-selectable').on('click', function(e) {
		e.preventDefault();

		$(this).toggleClass('state-selected');
	});
}

function delineateGridRows() {
	new delineate('.product-grid', {
		callback: function(lines) {
			$(lines).each(function(index, nextLine) {
				for (var i = 0; i < nextLine.length; i++) {
					var $nextEl = $(nextLine[i]).find('[data-aos]');
					if ($nextEl.length) {
						$nextEl.attr('data-aos-delay', i * 100);
					}
				}
			})
		}
	});
}

export function init() {
	initSelectableCards();
	initFinishSwitcher();
	delineateGridRows();
};
